import { jsx as _jsx } from "react/jsx-runtime";
import ReactPlayer from "react-player/file";
import "./BackgroundVideo.css";
export const BackgroundVideo = (props) => {
    let content;
    const onPlayerReady = () => {
    };
    const onError = (e) => {
        console.log("onError", e);
    };
    content = (_jsx("div", Object.assign({ id: "ReactPlayerVideo", style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            left: "0",
            top: "2px",
            justifyContent: "center",
            alignContent: "center",
        } }, { children: _jsx(ReactPlayer, { width: "100%", height: "auto", url: "./Videos/B-Roll.mp4", playing: true, loop: true, muted: true, pip: false, controls: false, playsinline: true, onReady: onPlayerReady, onError: onError, config: {
                attributes: {
                    disablePictureInPicture: false,
                },
            } }) })));
    return content;
};
